import React from 'react';
import { Row, Col } from 'react-bootstrap';
import styles from '../CategoryDivider/categoryDivider.module.css';
import Img from 'gatsby-image';
import { Link } from 'gatsby';

const CategoryDivider = ({
	productCategory1Image,
	productCategory1ImageTitle,
	productCategory1Description,
	productCategory1Link,
	productCategory1Name
}) => {
	return (
		<section>
			<Row className={styles.dividerHolder}>
				<Col xs={12} sm={6} md={5} lg={4}>
					<Img fluid={productCategory1Image} alt={productCategory1ImageTitle} />
				</Col>
				<Col xs={12} sm={6} md={5} lg={4} className={styles.textHolder}>
					<h2 className={styles.h2}>{productCategory1Name}</h2>
					<p>{productCategory1Description}</p>
					<Link to={`collections/${productCategory1Link}`} className={styles.btn}>
						SHOP NOW
					</Link>
				</Col>
			</Row>
		</section>
	);
};

export default CategoryDivider;
